module.exports = __webpack_public_path__ + "img/Ramadan1.a9b28ff2.png";